<template>
    <section id="explore_area" class="section_padding">
        <div class="container">
            <!-- Section Heading -->
            <div v-if="result?.data?.length > 0" class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="section_heading_center">
                        <h2 v-if="departure_selecting == 1">{{ $t('Flights Found') }} ({{ count }})</h2>
                        <h2 v-else>{{ $t('Summary of your flight order') }}</h2>
                    </div>
                </div>
            </div>
            <div class="row" id="target-div">
                <div class="col-lg-3">
                    <div v-if="result?.data?.length > 0" class="left_side_search_area relative">
                        <div class="disable"></div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Number of stops') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div v-for="(item, index) in stops" :key="item" class="form-check">
                                    <input class="form-check-input filter-stops" type="checkbox" :value="item"
                                        :disabled="index == 0 || this.tripType == 'multi_city' ? true : false"
                                        :checked="index == 0 ? true : false">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span v-if="item == 1">{{ $t('Non-stop') }}</span>
                                            <span v-else>{{ item - 1 }} {{ $t('Stop') }}</span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Airlines') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div v-for="(item, index) in airlines" :key="item.en" class="form-check">
                                    <input class="form-check-input filter-airlines" type="checkbox" :value="index"
                                        :disabled="Object.keys(airlines).length == 1 ? true : false" checked>
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>
                                                {{ $i18n.locale === 'en' ? item.en : item.ar }}
                                                <span v-if="trusted_partners.includes(index)"
                                                    style="color: #8354A3;font-weight: 700;">
                                                    ({{ $t('Trusted partner') }})
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Departure time') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <input class="form-check-input filter-time" type="checkbox" value="1" checked>
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>12:00 MN - 4:59 AM</span>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input filter-time" type="checkbox" value="2" checked>
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>05:00 AM - 11:59 AM</span>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input filter-time" type="checkbox" value="3" checked>
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>12:00 NN - 4:59 PM</span>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input filter-time" type="checkbox" value="4" checked>
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>05:00 PM - 11:59 PM</span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="left_side_search_area skeleton">
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="row">
                        <div v-if="this.tripType != 'multi_city'" class="col-lg-12" id="departure-result">
                            <div v-if="result?.data?.length > 0" class="flight_search_result_wrapper flight-result-con">
                                <div v-for='(item, index) in result.data' class="flight_search_item_wrappper">
                                    <div class="flight_search_items">
                                        <div class="multi_city_flight_lists w-100" data-bs-toggle="collapse"
                                            :data-bs-target="'#collapseExample' + item.id" aria-expanded="false"
                                            aria-controls="collapseExample">
                                            <div class="flight_multis_area_wrapper">
                                                <div class="flight_search_left">
                                                    <div class="flight_logo relative">
                                                        <div :class="'flight-image i-' + item.itineraries[0].segments[0].carrierCode.toString().toLowerCase()"
                                                            v-tooltip.top="result.airlines[item.itineraries[0].segments[0].carrierCode][$i18n.locale]">
                                                        </div>
                                                        <small
                                                            v-if="trusted_partners.includes(item.itineraries[0].segments[0].carrierCode)"
                                                            class="trusted-partner">
                                                            {{ $t('Trusted partner') }}
                                                        </small>
                                                    </div>
                                                    <div class="flight_search_destination">
                                                        <!-- <p>{{ $t('From') }}</p> -->
                                                        <h3>
                                                            {{ this.searchData.from }}

                                                        </h3>
                                                        <p class="time">
                                                            {{ new
                                                                Date(item.itineraries[0].segments[0].departure.at).toLocaleTimeString('fr-FR',
                                                                    {
                                                                        hour:
                                                                            '2-digit', minute: '2-digit'
                                                                    }) }}
                                                        </p>
                                                        <p class="date">
                                                            {{ new
                                                                Date(item.itineraries[0].segments[0].departure.at).toLocaleDateString('en-US',
                                                                    { day: 'numeric' }) }}
                                                            {{ $t(new
                                                                Date(item.itineraries[0].segments[0].departure.at).toLocaleDateString('en-US',
                                                                    {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                            {{ new
                                                                Date(item.itineraries[0].segments[0].departure.at).getFullYear()
                                                            }}
                                                        </p>
                                                        <h6>{{
                                                            getLocationByCode(this.searchData.from)['name'] }}</h6>
                                                    </div>
                                                </div>
                                                <div class="flight_right_arrow">
                                                    <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                        alt="img" />
                                                    <h6>
                                                        {{
                                                            item.itineraries[0].segments.length - 1 == 0 ?
                                                                $t('Direct Flight')
                                                                : item.itineraries[0].segments.length - 1 + ' ' + $t('Stop')
                                                        }}
                                                    </h6>
                                                    <p>{{ convertDuration(item.itineraries[0].duration) }}</p>
                                                </div>
                                                <div class="flight_search_middel">
                                                    <div class="flight_search_destination">
                                                        <!-- <p>{{ $t('To') }}</p> -->
                                                        <h3>
                                                            {{ this.searchData.to }}

                                                        </h3>
                                                        <p class="time">
                                                            {{ new
                                                                Date(item.itineraries[0].segments[item.itineraries[0].segments.length
                                                                    - 1].arrival.at).toLocaleTimeString('fr-FR',
                                                                        {
                                                                            hour:
                                                                                '2-digit', minute: '2-digit'
                                                                        }) }}
                                                        </p>
                                                        <p class="date">
                                                            {{ new
                                                                Date(item.itineraries[0].segments[item.itineraries[0].segments.length
                                                                    - 1].arrival.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                            {{ $t(new
                                                                Date(item.itineraries[0].segments[item.itineraries[0].segments.length
                                                                    - 1].arrival.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                            {{ new
                                                                Date(item.itineraries[0].segments[item.itineraries[0].segments.length
                                                                    - 1].arrival.at).getFullYear() }}
                                                        </p>
                                                        <h6>{{
                                                            getLocationByCode(this.searchData.to)['name'] }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 class="show" data-bs-toggle="collapse"
                                                :data-bs-target="'#collapseExample' + item.id" aria-expanded="false"
                                                aria-controls="collapseExample">{{ $t('Show more')
                                                }}<i class="fas fa-chevron-down"></i></h6>
                                            <div class="dduKua">
                                                <span>
                                                    {{ $t('seats') }} : {{ item.numberOfBookableSeats }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <h3 v-if="is_self_paying == 1" class="price">
                                                {{ get_price_with_markup(item.price.grandTotal) }}
                                                <span class="primary-color">{{ $t('SAR') }}</span>
                                            </h3>
                                            <div v-if="this.allowed_to_make_exception == 1 && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="arrow-ribbone-right bg-info">
                                                {{ $t('need approval') }}
                                            </div>
                                            <a :data-details="JSON.stringify(item)" data-type="0"
                                                :data-need-approval="this.allowed_to_make_exception == 1 && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="btn btn_theme btn_sm select-flight">
                                                <span>
                                                    {{
                                                        this.allowed_to_make_exception == 1
                                                            && item.travelerPricings[0].price.total > this.max_ticket_price
                                                            ? $t('request approval')
                                                            : $t('Select Flight')
                                                    }}
                                                </span>
                                                <lv-loader type="ball-pulse" style="display: none;" :color="'#fff'"
                                                    :scale="'0.7'" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="flight_policy_refund collapse" :id="'collapseExample' + item.id">
                                        <div v-for='(segment, index) in item.itineraries[0].segments'
                                            class="flight_show_down_wrapper">
                                            <div class="flight-shoe_dow_item d-flex w-100">
                                                <div class="airline-details mt-2">
                                                    <div class="img">
                                                        <div
                                                            :class="'flight-image  flight-image-sm i-' + segment.carrierCode.toString().toLowerCase()">
                                                        </div>
                                                    </div>
                                                    <span class="airlineName fw-500">{{
                                                        result.airlines[segment.carrierCode][$i18n.locale] }}
                                                        &nbsp;
                                                        {{ segment.carrierCode }}{{ segment.number }}</span>
                                                </div>
                                                <div class="flight_inner_show_component w-70">
                                                    <div class="flight_det_wrapper">
                                                        <div class="flight_det">
                                                            <div class="code_time">
                                                                <span class="code">{{ segment.departure.iataCode
                                                                    }}</span>
                                                                <span class="time">
                                                                    {{ new
                                                                        Date(segment.departure.at).toLocaleTimeString('fr-FR',
                                                                            {
                                                                                hour:
                                                                                    '2-digit', minute: '2-digit'
                                                                            }) }}
                                                                </span>
                                                            </div>
                                                            <p class="airport">
                                                                {{ getLocationByCode(segment.departure.iataCode)['name']
                                                                }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.departure.at).getFullYear() }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flight_duration">
                                                        <div class="arrow_right"></div>
                                                        <span>
                                                            {{ convertDuration(segment.duration) }}
                                                        </span>
                                                    </div>
                                                    <div class="flight_det_wrapper">
                                                        <div class="flight_det">
                                                            <div class="code_time">
                                                                <span class="code">{{ segment.arrival.iataCode }}</span>
                                                                <span class="time">
                                                                    {{ new
                                                                        Date(segment.arrival.at).toLocaleTimeString('fr-FR',
                                                                            {
                                                                                hour:
                                                                                    '2-digit', minute: '2-digit'
                                                                            }) }}
                                                                </span>
                                                            </div>
                                                            <p class="airport">
                                                                {{ getLocationByCode(segment.arrival.iataCode)['name']
                                                                }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.arrival.at).getFullYear() }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {{ $t('Number of bags') }} : {{
                                                            getFareDetailsBySegmentId(item.travelerPricings, segment.id) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="flight_search_result_wrapper skeleton">
                                <div v-for='(item, index) in 10' class="flight_search_item_wrappper">
                                    <div class="flight_search_items">
                                        <div class="multi_city_flight_lists w-100">
                                            <div class="flight_multis_area_wrapper">
                                                <div class="flight_search_left">
                                                    <div class="flight_logo">
                                                        <img :src="require(`@/assets/icons/default_70.png`)"
                                                            alt="img" />
                                                    </div>
                                                    <div class="flight_search_destination">
                                                        <p>
                                                            <lv-skeleton :width="75" :height="15" />
                                                        </p>
                                                        <h3>
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </h3>
                                                        <h6>
                                                            <lv-skeleton :width="150" :height="15" />
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="flight_right_arrow">
                                                    <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                        alt="img" />
                                                    <h6>
                                                        <lv-skeleton :width="100" :height="15" />
                                                    </h6>
                                                    <p class="mt-2">
                                                        <lv-skeleton :width="100" :height="15" />
                                                    </p>
                                                </div>
                                                <div class="flight_search_middel">

                                                    <div class="flight_search_destination">
                                                        <p>
                                                            <lv-skeleton :width="75" :height="15" />
                                                        </p>
                                                        <h3>
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </h3>
                                                        <h6>
                                                            <lv-skeleton :width="150" :height="15" />
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <h2>
                                                <lv-skeleton :width="125" :height="15" />
                                            </h2>
                                            <lv-skeleton :width="125" :height="15" />

                                            <h6>
                                                <lv-skeleton :width="125" :height="15" />
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="selected-flight"></div>
                        </div>
                        <div v-if="this.tripType != 'multi_city'" class="col-lg-12 d-none2" id="arrival-result">
                            <h4 v-if="arrival_selecting == 1" class="no-margin text-center mb-3 ml5 mr5 count-arrival">
                                <span class="new-bold-dark font-20 arrival">{{ $t('Return Flight') }}</span>
                                <span class="flight-count new-bold-dark"> ({{ count }}) </span>
                                <span class="flight-count new-bold-dark">{{ $t('Results') }}</span>
                            </h4>
                            <h4 v-else class="no-margin text-center mb-3 ml5 mr5 count-arrival">
                                <span class="new-bold-dark font-20 arrival">{{ $t('Return flight') }}</span>
                            </h4>
                            <div class="flight_search_result_wrapper flight-result-con">
                                <div v-for='(item, index) in arrival_results' class="flight_search_item_wrappper">
                                    <div class="flight_search_items">
                                        <div class="multi_city_flight_lists w-100" data-bs-toggle="collapse"
                                            :data-bs-target="'#collapseExample' + item.id" aria-expanded="false"
                                            aria-controls="collapseExample">
                                            <div class="flight_multis_area_wrapper">
                                                <div class="flight_search_left">
                                                    <div class="flight_logo relative">
                                                        <div :class="'flight-image i-' + item.itineraries[1].segments[0].carrierCode.toString().toLowerCase()"
                                                            v-tooltip.top="result.airlines[item.itineraries[1].segments[0].carrierCode][$i18n.locale]">
                                                        </div>
                                                        <small
                                                            v-if="trusted_partners.includes(item.itineraries[1].segments[0].carrierCode)"
                                                            class="trusted-partner">
                                                            {{ $t('Trusted partner') }}
                                                        </small>
                                                    </div>
                                                    <div class="flight_search_destination">
                                                        <!-- <p>{{ $t('From') }}</p> -->
                                                        <h3>{{ this.searchData.to }}</h3>
                                                        <p class="time">
                                                            {{ new
                                                                Date(item.itineraries[1].segments[0].departure.at).toLocaleTimeString('fr-FR',
                                                                    {
                                                                        hour:
                                                                            '2-digit', minute: '2-digit'
                                                                    }) }}
                                                        </p>
                                                        <p class="date">
                                                            {{ new
                                                                Date(item.itineraries[1].segments[0].departure.at).toLocaleDateString('en-US',
                                                                    { day: 'numeric' }) }}
                                                            {{ $t(new
                                                                Date(item.itineraries[1].segments[0].departure.at).toLocaleDateString('en-US',
                                                                    {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                            {{ new
                                                                Date(item.itineraries[1].segments[0].departure.at).getFullYear()
                                                            }}
                                                        </p>
                                                        <h6>{{
                                                            getLocationByCode(this.searchData.to)['name'] }}</h6>
                                                    </div>
                                                </div>
                                                <div class="flight_right_arrow">
                                                    <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                        alt="img" />
                                                    <h6>
                                                        {{
                                                            item.itineraries[1].segments.length - 1 == 0 ?
                                                                $t('Direct Flight')
                                                                : item.itineraries[1].segments.length - 1 + ' ' + $t('Stop')
                                                        }}
                                                    </h6>
                                                    <p>{{ convertDuration(item.itineraries[1].duration) }}</p>
                                                </div>
                                                <div class="flight_search_middel">

                                                    <div class="flight_search_destination">
                                                        <!-- <p>{{ $t('To') }}</p> -->
                                                        <h3>{{ this.searchData.from }}</h3>
                                                        <p class="time">
                                                            {{ new
                                                                Date(item.itineraries[1].segments[item.itineraries[1].segments.length
                                                                    - 1].arrival.at).toLocaleTimeString('fr-FR',
                                                                        {
                                                                            hour:
                                                                                '2-digit', minute: '2-digit'
                                                                        }) }}
                                                        </p>
                                                        <p class="date">
                                                            {{ new
                                                                Date(item.itineraries[1].segments[item.itineraries[1].segments.length
                                                                    - 1].arrival.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                            {{ $t(new
                                                                Date(item.itineraries[1].segments[item.itineraries[1].segments.length
                                                                    - 1].arrival.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                            {{ new
                                                                Date(item.itineraries[1].segments[item.itineraries[1].segments.length
                                                                    - 1].arrival.at).getFullYear() }}
                                                        </p>
                                                        <h6>{{
                                                            getLocationByCode(this.searchData.from)['name'] }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 class="show" data-bs-toggle="collapse"
                                                :data-bs-target="'#collapseExample' + item.id" aria-expanded="false"
                                                aria-controls="collapseExample">{{ $t('Show more')
                                                }}<i class="fas fa-chevron-down"></i></h6>
                                            <div class="dduKua">
                                                <span>
                                                    {{ $t('seats') }} : {{ item.numberOfBookableSeats }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <h3 v-if="is_self_paying == 1" class="price">
                                                {{ get_price_with_markup(item.price.grandTotal) }}
                                                <span class="primary-color">{{ $t('SAR') }}</span>
                                            </h3>
                                            <div v-if="this.allowed_to_make_exception == 1
                                                && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="arrow-ribbone-right bg-info">
                                                {{ $t('need approval') }}
                                            </div>
                                            <a :data-details="JSON.stringify(item)" data-type="1"
                                                :data-need-approval="this.allowed_to_make_exception == 1 && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="btn btn_theme btn_sm select-flight">
                                                <span>
                                                    {{
                                                        this.allowed_to_make_exception == 1
                                                            && item.travelerPricings[0].price.total > this.max_ticket_price
                                                            ? $t('request approval')
                                                            : $t('Select Flight')
                                                    }}
                                                </span>
                                                <lv-loader type="ball-pulse" style="display: none;" :color="'#fff'"
                                                    :scale="'0.7'" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="flight_policy_refund collapse" :id="'collapseExample' + item.id">
                                        <div v-for='(segment, index) in item.itineraries[1].segments'
                                            class="flight_show_down_wrapper">
                                            <div class="flight-shoe_dow_item d-flex w-100">
                                                <div class="airline-details mt-2">
                                                    <div class="img">
                                                        <div
                                                            :class="'flight-image  flight-image-sm i-' + segment.carrierCode.toString().toLowerCase()">
                                                        </div>
                                                    </div>
                                                    <span class="airlineName fw-500">{{
                                                        result.airlines[segment.carrierCode][$i18n.locale] }}
                                                        &nbsp;
                                                        {{ segment.carrierCode }}{{ segment.number }}</span>
                                                </div>
                                                <div class="flight_inner_show_component w-70">
                                                    <div class="flight_det_wrapper">
                                                        <div class="flight_det">
                                                            <div class="code_time">
                                                                <span class="code">{{ segment.departure.iataCode
                                                                    }}</span>
                                                                <span class="time">
                                                                    {{ new
                                                                        Date(segment.departure.at).toLocaleTimeString('fr-FR',
                                                                            {
                                                                                hour:
                                                                                    '2-digit', minute: '2-digit'
                                                                            }) }}
                                                                </span>
                                                            </div>
                                                            <p class="airport">
                                                                {{ getLocationByCode(segment.departure.iataCode)['name']
                                                                }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.departure.at).getFullYear() }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flight_duration">
                                                        <div class="arrow_right"></div>
                                                        <span>
                                                            {{ convertDuration(segment.duration) }}
                                                        </span>
                                                    </div>
                                                    <div class="flight_det_wrapper">
                                                        <div class="flight_det">
                                                            <div class="code_time">
                                                                <span class="code">{{ segment.arrival.iataCode }}</span>
                                                                <span class="time">
                                                                    {{ new
                                                                        Date(segment.arrival.at).toLocaleTimeString('fr-FR',
                                                                            {
                                                                                hour:
                                                                                    '2-digit', minute: '2-digit'
                                                                            }) }}
                                                                </span>
                                                            </div>
                                                            <p class="airport">
                                                                {{ getLocationByCode(segment.arrival.iataCode)['name']
                                                                }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.arrival.at).getFullYear() }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {{ $t('Number of bags') }} : {{
                                                            getFareDetailsBySegmentId(item.travelerPricings, segment.id) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="selected-flight"></div>
                        </div>
                        <div v-if="this.tripType == 'multi_city'" class="col-lg-12" id="departure-result">
                            <div v-if="result?.data?.length > 0" class="flight_search_result_wrapper flight-result-con">
                                <div v-for='(item, index) in result.data' class="flight_search_item_wrappper">
                                    <div class="flight_search_items multi_city">
                                        <div class="multi_city_flight_lists w-100">
                                            <div v-for='(itinerarie, index) in item.itineraries' class="itineraries">
                                                <div v-for='(segment, index) in itinerarie.segments'
                                                    class="flight_multis_area_wrapper">
                                                    <div class="flight_search_left">
                                                        <div class="flight_logo">
                                                            <div :class="'flight-image i-' + segment.carrierCode.toString().toLowerCase()"
                                                                v-tooltip.top="result.airlines[segment.carrierCode][$i18n.locale]">
                                                            </div>
                                                        </div>
                                                        <div class="flight_search_destination">
                                                            <!-- <p>{{ $t('From') }}</p> -->
                                                            <h3>{{ segment.departure.iataCode }}
                                                            </h3>
                                                            <p class="time">
                                                                {{ new
                                                                    Date(segment.departure.at).toLocaleTimeString('fr-FR',
                                                                        {
                                                                            hour:
                                                                                '2-digit', minute: '2-digit'
                                                                        }) }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.departure.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.departure.at).getFullYear() }}
                                                            </p>
                                                            <h6>{{
                                                                getLocationByCode(segment.departure.iataCode)['name'] }}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div class="flight_right_arrow">
                                                        <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                            alt="img" />
                                                        <h6>
                                                            {{ new
                                                                Date(segment.departure.at).toLocaleDateString('en-US',
                                                                    { day: 'numeric' }) }}
                                                            {{ $t(new
                                                                Date(segment.departure.at).toLocaleDateString('en-US', {
                                                                    month:
                                                                        'long'
                                                                })) }}
                                                            {{ new
                                                                Date(segment.departure.at).getFullYear() }}
                                                        </h6>
                                                        <p>{{ convertDuration(segment.duration) }}</p>
                                                    </div>
                                                    <div class="flight_search_middel">
                                                        <div class="flight_search_destination">
                                                            <!-- <p>{{ $t('To') }}</p> -->
                                                            <h3>{{ segment.arrival.iataCode }}
                                                            </h3>
                                                            <p class="time">
                                                                {{ new
                                                                    Date(segment.arrival.at).toLocaleTimeString('fr-FR',
                                                                        {
                                                                            hour:
                                                                                '2-digit', minute: '2-digit'
                                                                        }) }}
                                                            </p>
                                                            <p class="date">
                                                                {{ new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US',
                                                                        { day: 'numeric' }) }}
                                                                {{ $t(new
                                                                    Date(segment.arrival.at).toLocaleDateString('en-US', {
                                                                        month:
                                                                            'long'
                                                                    })) }}
                                                                {{ new
                                                                    Date(segment.arrival.at).getFullYear() }}
                                                            </p>
                                                            <h6>{{
                                                                getLocationByCode(segment.arrival.iataCode)['name'] }}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dduKua">
                                                <span>
                                                    {{ $t('seats') }} : {{ item.numberOfBookableSeats }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <h3 v-if="is_self_paying == 1" class="price">
                                                {{ get_price_with_markup(item.price.grandTotal) }}
                                                <span class="primary-color">{{ $t('SAR') }}</span>
                                            </h3>
                                            <div v-if="this.allowed_to_make_exception == 1
                                                && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="arrow-ribbone-right bg-info">
                                                {{ $t('need approval') }}
                                            </div>
                                            <a :data-details="JSON.stringify(item)" data-type="0"
                                                :data-need-approval="this.allowed_to_make_exception == 1 && item.travelerPricings[0].price.total > this.max_ticket_price"
                                                class="btn btn_theme btn_sm select-flight">
                                                <span>
                                                    {{
                                                        this.allowed_to_make_exception == 1
                                                            && item.travelerPricings[0].price.total > this.max_ticket_price
                                                            ? $t('request approval')
                                                            : $t('Select Flight')
                                                    }}
                                                </span>
                                                <lv-loader type="ball-pulse" style="display: none;" :color="'#fff'"
                                                    :scale="'0.7'" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="flight_search_result_wrapper skeleton">
                                <div v-for='(item, index) in 10' class="flight_search_item_wrappper">
                                    <div class="flight_search_items multi_city">
                                        <div class="multi_city_flight_lists w-100">
                                            <div class="itineraries">

                                                <div class="flight_multis_area_wrapper ">
                                                    <div class="flight_search_left">
                                                        <div class="flight_logo">
                                                            <img :src="require(`@/assets/icons/default_70.png`)"
                                                                alt="img" />
                                                        </div>
                                                        <div class="flight_search_destination">
                                                            <p>
                                                                <lv-skeleton :width="75" :height="15" />
                                                            </p>
                                                            <h3>
                                                                <lv-skeleton :width="100" :height="15" />
                                                            </h3>
                                                            <h6>
                                                                <lv-skeleton :width="150" :height="15" />
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div class="flight_right_arrow">
                                                        <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                            alt="img" />
                                                        <h6>
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </h6>
                                                        <p class="mt-2">
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </p>
                                                    </div>
                                                    <div class="flight_search_middel">
                                                        <div class="flight_search_destination">
                                                            <p>
                                                                <lv-skeleton :width="75" :height="15" />
                                                            </p>
                                                            <h3>
                                                                <lv-skeleton :width="100" :height="15" />
                                                            </h3>
                                                            <h6>
                                                                <lv-skeleton :width="150" :height="15" />
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="itineraries">

                                                <div class="flight_multis_area_wrapper ">
                                                    <div class="flight_search_left">
                                                        <div class="flight_logo">
                                                            <img :src="require(`@/assets/icons/default_70.png`)"
                                                                alt="img" />
                                                        </div>
                                                        <div class="flight_search_destination">
                                                            <p>
                                                                <lv-skeleton :width="75" :height="15" />
                                                            </p>
                                                            <h3>
                                                                <lv-skeleton :width="100" :height="15" />
                                                            </h3>
                                                            <h6>
                                                                <lv-skeleton :width="150" :height="15" />
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div class="flight_right_arrow">
                                                        <img :src="require(`@/assets/img/icon/right_arrow.png`)"
                                                            alt="img" />
                                                        <h6>
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </h6>
                                                        <p class="mt-2">
                                                            <lv-skeleton :width="100" :height="15" />
                                                        </p>
                                                    </div>
                                                    <div class="flight_search_middel">
                                                        <div class="flight_search_destination">
                                                            <p>
                                                                <lv-skeleton :width="75" :height="15" />
                                                            </p>
                                                            <h3>
                                                                <lv-skeleton :width="100" :height="15" />
                                                            </h3>
                                                            <h6>
                                                                <lv-skeleton :width="150" :height="15" />
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <h2>
                                                <lv-skeleton :width="125" :height="15" />
                                            </h2>
                                            <lv-skeleton :width="125" :height="15" />

                                            <h6>
                                                <lv-skeleton :width="125" :height="15" />
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="selected-flight"></div>
                        </div>
                        <div class="col-lg-12  text-right price-fl" style="display: none;">
                            <button class="btn btn-fa-primary  p15 btn-block w-30  pull-right" @click="add_passenger">
                                <span class="no-margin bold">{{ $t('next') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
var that;
import $ from 'jquery';
import Slider from '@vueform/slider';
import jsonDataAr from '@/assets/file/ar-airports.json';
import jsonDataEn from '@/assets/file/en-airports.json';
import airlinesData from '@/assets/file/airlines.json';
import { toast } from 'vue3-toastify';
import LvSkeleton from 'lightvue/skeleton';
import Tooltip from 'lightvue/tooltip';
import LvLoader from 'lightvue/loaders';
import flightsService from '@/services/jsky/flights/flights-service';
export default {
    name: "SearchResult",
    components: {
        Slider,
        LvSkeleton,
        LvLoader
    },
    directives: {
        tooltip: Tooltip,
    },
    data() {
        return {
            result: [],
            arrival_results: [],
            date: '',
            ret_date: '',
            airlines: [],
            allData: [],
            count: 0,
            arrival_total: 0,
            departure_total: 0,
            stops: [],
            searchData: [],
            tripType: '',
            departure_selecting: 1,
            arrival_selecting: 1,
            selected_airline: '',
            max_ticket_price: 50000,
            allowed_to_make_exception: 0,
            is_self_paying: 0,
            trusted_partners: ['EK']
        }
    },
    methods: {
        get_price_with_markup(price) {
            price = parseFloat(price);
            var markup_percent = 0.1;
            var total = (price + (price * markup_percent)).toLocaleString(undefined, { minimumFractionDigits: 2 });
            return total;
        },
        filterByDepartureTime(flightOffer) {
            const itineraries = flightOffer.itineraries[this.departure_selecting == 1 ? 0 : 1] || [];
            const selectedTimeRanges = this.getSelectedTimeRanges();
            const checked_airlines = $('.filter-airlines:checked').map(function () {
                return $(this).val();
            }).get();
            var array = [];
            $(".filter-stops").each(function () {
                if ($(this).prop('checked') == true) {
                    array.push(parseInt($(this).val()));
                }
            });
            return itineraries.segments.some(segment => {
                const departureTime = new Date(segment.departure.at).getHours();
                if (this.departure_selecting == 1) {
                    return selectedTimeRanges.includes(this.getTimeRange(departureTime)) && this.isArrayIncluded(checked_airlines, flightOffer.validatingAirlineCodes) && array.includes(itineraries.segments.length);
                } else {
                    return selectedTimeRanges.includes(this.getTimeRange(departureTime)) && flightOffer.validatingAirlineCodes.includes(that.selected_airline) && array.includes(itineraries.segments.length);
                }
            });
        },
        isArrayIncluded(array1, array2) {
            return array2.every(element => array1.includes(element));
        },
        getSelectedTimeRanges() {
            const selectedCheckboxes = document.querySelectorAll('.filter-time:checked');
            const selectedTimeRanges = Array.from(selectedCheckboxes).map(checkbox => checkbox.value);
            return selectedTimeRanges;
        },
        getTimeRange(hour) {
            if (hour >= 0 && hour < 5) {
                return '1';
            } else if (hour >= 5 && hour <= 11) {
                return '2';
            } else if (hour >= 12 && hour <= 16) {
                return '3';
            } else if (hour >= 17 && hour <= 23) {
                return '4';
            } else {
                return '0';
            }
        },
        getUniqueSegmentLengths(flightOffers) {
            const uniqueSegmentLengths = new Set();
            flightOffers.forEach((offer) => {
                if (this.departure_selecting == 1) {
                    offer.itineraries.forEach((itinerary, index) => {
                        if (index == 0) {
                            uniqueSegmentLengths.add(itinerary.segments.length);
                        }
                    });
                } else {
                    offer.itineraries.forEach((itinerary, index) => {
                        if (index == 1) {
                            uniqueSegmentLengths.add(itinerary.segments.length);
                        }
                    });
                }
            });
            return Array.from(uniqueSegmentLengths);
        },
        getLocationByCode(code) {
            var jsonData = jsonDataAr;
            if (that.$i18n.locale === 'en') {
                jsonData = jsonDataEn;
            }
            var info = jsonData.filter(item => {
                return item.code.includes(code);
            });
            return info[0];
        },
        convertDuration(duration) {
            const regex = /PT(\d+)H(\d+)M/;
            const regex2 = /PT(\d+)H/;
            const match = regex.exec(duration);
            const match2 = regex2.exec(duration);
            if (match) {
                const hours = match[1].padStart(2, '0');
                const minutes = match[2].padStart(2, '0');
                if (that.$i18n.locale === 'en') {
                    return hours + 'h ' + minutes + 'm';
                }
                return hours + 'س ' + minutes + 'د';
            } else if (match2) {
                const hours = match2[1].padStart(2, '0');
                const minutes = '00';
                if (that.$i18n.locale === 'en') {
                    return hours + 'h ' + minutes + 'm';
                }
                return hours + 'س ' + minutes + 'د';
            }
            return '';
        },
        add_passenger() {
            window.location = `/flight-booking-submission`;
        },
        getFareDetailsBySegmentId(travelerPricings, segmentId) {
            var travelerPricing = travelerPricings[0].fareDetailsBySegment.filter(item => {
                return item.segmentId == segmentId;
            });
            if (travelerPricing.length) {
                travelerPricing = travelerPricing[0];
                return travelerPricing.includedCheckedBags.quantity ?? 0;
            }
            return 0;
        },
        uncheckAllExceptByValue(checkboxValue) {
            const checkboxes = $(document).find('.filter-stops');
            checkboxes.each(function () {
                if ($(this).val() !== checkboxValue) {
                    $(this).prop('checked', false);
                    $(this).trigger('change');
                }
            });
        },
        Jquery() {
            $(document).on('change', '.filter-time', function (e) {
                var filter_time = $('.filter-time:checked').length;
                if (filter_time == 1) {
                    $(".filter-time").each(function () {
                        if ($(this).prop('checked') == true) {
                            $(this).attr('disabled', true);
                        }
                    });
                } else {
                    $(".filter-time").attr('disabled', false);
                }
                const filteredFlights = that.allData.data.filter(that.filterByDepartureTime);
                if (filteredFlights.length == 0) {
                    $(this).prop('checked', true);
                    toast.error(that.$t('There are no matching flights'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                if (that.departure_selecting == 1) {
                    that.count = filteredFlights.length;
                    that.result.data = filteredFlights;
                } else {
                    that.count = filteredFlights.length;
                    that.arrival_results = filteredFlights;
                }
            });
            $(document).on('change', '.filter-airlines', function (e) {
                var array = [];
                $(".filter-airlines").each(function () {
                    if ($(this).prop('checked') == true) {
                        array.push($(this).val());
                    }
                });
                if (array.length == 1) {
                    $(".filter-airlines").each(function () {
                        if ($(this).prop('checked') == true) {
                            $(this).attr('disabled', true);
                        }
                    });
                } else {
                    $(".filter-airlines").attr('disabled', false);
                }
                var filter_stops = [];
                $(".filter-stops").each(function () {
                    if ($(this).prop('checked') == true) {
                        filter_stops.push(parseInt($(this).val()));
                    }
                });
                const filteredFlights = that.allData.data.filter((flight) => {
                    for (const itinerary of flight.itineraries) {
                        for (const segment of itinerary.segments) {
                            if (array.includes(segment.carrierCode) && filter_stops.includes(itinerary.segments.length)) {
                                return true;
                            }
                        }
                    }
                    return false;
                });
                if (filteredFlights.length == 0) {
                    $(this).prop('checked', true);
                    toast.error(that.$t('There are no matching flights'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                that.count = filteredFlights.length;
                that.result.data = filteredFlights;
                $('.filter-time').trigger('change');
            });
            $(document).on('change', '.filter-stops', function () {
                var array = [];
                $(".filter-stops").each(function () {
                    if ($(this).prop('checked') == true) {
                        array.push(parseInt($(this).val()));
                    }
                });
                if (array.length == 1) {
                    $(".filter-stops").each(function () {
                        if ($(this).prop('checked') == true) {
                            $(this).attr('disabled', true);
                        }
                    });
                } else {
                    $(".filter-stops").attr('disabled', false);
                }

                if (that.departure_selecting == 1) {
                    const checked_airlines = $('.filter-airlines:checked').map(function () {
                        return $(this).val();
                    }).get();
                    const filteredFlights = that.allData.data.filter((flight) => {
                        if (array.includes(flight.itineraries[0].segments.length) && that.isArrayIncluded(checked_airlines, flight.validatingAirlineCodes)) {
                            return true;
                        }
                        return false;
                    });
                    if (filteredFlights.length == 0) {
                        $(this).prop('checked', true);
                        toast.error(that.$t('There are no matching flights'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    }
                    that.count = filteredFlights.length;
                    that.result.data = filteredFlights;
                } else {
                    const filteredFlights = that.allData.data.filter((flight) => {
                        if (array.includes(flight.itineraries[1].segments.length) && flight.validatingAirlineCodes.includes(that.selected_airline)) {
                            return true;
                        }
                        return false;
                    });
                    if (filteredFlights.length == 0) {
                        $(this).prop('checked', true);
                        toast.error(that.$t('There are no matching flights'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    }
                    that.count = filteredFlights.length;
                    that.arrival_results = filteredFlights;
                }
                $('.filter-time').trigger('change');
            });
            $(document).on('click', '.select-flight', function () {
                var details = $(this).data('details');
                var type = $(this).data('type');
                var need_approval = $(this).data('need-approval');
                $(this).prop('disabled', true);
                $(this).find('span').hide();
                $(this).find('.loader-inner').show();
                setTimeout(() => {
                    if (that.tripType == 'roundtrip') {
                        if (type == 0) {
                            setTimeout(() => {
                                $("html, body").animate({
                                    scrollTop: $("#arrival-result").offset().top - 200
                                }, 10);
                            }, 100);
                            if (need_approval == true) {
                                localStorage.setItem('need_approval', 1);
                            } else {
                                localStorage.setItem('need_approval', 0);
                            }
                            that.departure_selecting = 0;
                            that.stops = that.getUniqueSegmentLengths(that.allData.data).sort(function (a, b) {
                                return a - b;
                            });
                            $(".filter-stops").each(function (index) {
                                if (index == 0) {
                                    $(this).prop('checked', true);
                                } else {
                                    $(this).prop('checked', false);
                                }
                            });
                            $(".filter-airlines").attr('disabled', true);
                            localStorage.setItem('departure_flight', JSON.stringify(details));
                            var airline = details.validatingAirlineCodes[0];
                            that.selected_airline = airline;

                            var array = [that.stops[0]];
                            that.arrival_results = that.allData.data.filter((flight) => {
                                if (array.includes(flight.itineraries[1].segments.length) && flight.validatingAirlineCodes.includes(airline)) {
                                    return true;
                                }
                                return false;
                            });
                            that.count = that.arrival_results.length;

                            $('#arrival-result').show();
                            $('#arrival-result .flight-result-con').show();
                            $('#arrival-result .flight-count').show();

                            $('#departure-result .flight-result-con').hide();
                            $('#departure-result .selected-flight').show();
                            $('#departure-result .selected-flight').html(`
                    <div class="flight_search_item_wrappper">
                                    <div class="flight_search_items">
                                        <div class="multi_city_flight_lists w-100">
                                            <div class="flight_multis_area_wrapper">
                                                <div class="flight_search_left">
                                                    <div class="flight_logo">
                                                        <div class="flight-image i-${details.itineraries[0].segments[0].carrierCode.toString().toLowerCase()}">
                                                        </div>
                                                    </div>
                                                    <div class="flight_search_destination">
                                                        <h3>${that.searchData.from}</h3>
                                                        <p class="time">
                                                            ${new
                                    Date(details.itineraries[0].segments[0].departure.at).toLocaleTimeString('fr-FR',
                                        {
                                            hour:
                                                '2-digit', minute: '2-digit'
                                        })}
                                                        </p>
                                                        <p class="date">
                                                            ${new
                                    Date(details.itineraries[0].segments[0].departure.at).toLocaleDateString('en-US',
                                        { day: 'numeric' })}
                                                            ${that.$t(new
                                            Date(details.itineraries[0].segments[0].departure.at).toLocaleDateString('en-US', {
                                                month:
                                                    'long'
                                            }))}
                                                            ${new
                                    Date(details.itineraries[0].segments[0].departure.at).getFullYear()}
                                                        </p>
                                                        <h6>${that.getLocationByCode(that.searchData.from)['name']}</h6>
                                                    </div>
                                                </div>
                                                <div class="flight_right_arrow">
                                                        <img src="${require(`@/assets/img/icon/right_arrow.png`)}"
                                                            alt="img" />
                                                        <h6>
                                                            ${details.itineraries[0].segments.length - 1 == 0 ?
                                    that.$t('Direct Flight')
                                    : details.itineraries[0].segments.length - 1 + ' ' + that.$t('Stop')
                                }
                                                        </h6>
                                                        <p>${that.convertDuration(details.itineraries[0].duration)}</p>
                                                    </div>
                                                <div class="flight_search_middel">
                                                    <div class="flight_search_destination">
                                                        <h3>${that.searchData.to}</h3>
                                                        <p class="time">
                                                            ${new
                                    Date(details.itineraries[0].segments[details.itineraries[0].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR',
                                        {
                                            hour:
                                                '2-digit', minute: '2-digit'
                                        })}
                                                        </p>
                                                        <p class="date">
                                                            ${new
                                    Date(details.itineraries[0].segments[details.itineraries[0].segments.length - 1].arrival.at).toLocaleDateString('en-US',
                                        { day: 'numeric' })}
                                                            ${that.$t(new
                                            Date(details.itineraries[0].segments[details.itineraries[0].segments.length - 1].arrival.at).toLocaleDateString('en-US', {
                                                month:
                                                    'long'
                                            }))}
                                                            ${new
                                    Date(details.itineraries[0].segments[details.itineraries[0].segments.length - 1].arrival.at).getFullYear()}
                                                        </p>
                                                        <h6>${that.getLocationByCode(that.searchData.to)['name']}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <a 
                                                class="btn btn_theme btn_sm change-flight" data-type="departure">
                                                <span>${that.$t('Change')}</span>
                                                <div data-v-caebf3bc="" class="loader-inner ball-pulse" style="transform: scale(0.7); display: none;"><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div></div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                    `);
                        } else {
                            if (need_approval == true) {
                                localStorage.setItem('need_approval', 1);
                            }
                            that.arrival_selecting = 0;
                            localStorage.setItem('arrival_flight', JSON.stringify(details));
                            let departure_flight = JSON.parse(localStorage.getItem('departure_flight'));
                            let arrival_flight = JSON.parse(localStorage.getItem('arrival_flight'));
                            var flight = null;
                            var arrival_total = parseFloat(arrival_flight.price.grandTotal),
                                departure_total = parseFloat(departure_flight.price.grandTotal),
                                flight_total = 0;
                            if (arrival_total > departure_total) {
                                flight = arrival_flight;
                                flight_total = parseFloat(arrival_flight.price.grandTotal);
                            } else {
                                flight = departure_flight;
                                flight_total = parseFloat(departure_flight.price.grandTotal);
                            }
                            $('#arrival-result .flight-result-con').hide();
                            $('.price-fl .fl-total').html(' ' + (flight_total).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ' ');
                            $('.price-fl .fl-currency').html(that.$t(flight.price.currency));
                            $('#arrival-result .selected-flight').html(`
                            <div class="flight_search_item_wrappper">
                                    <div class="flight_search_items">
                                        <div class="multi_city_flight_lists w-100">
                                            <div class="flight_multis_area_wrapper">
                                                <div class="flight_search_left">
                                                    <div class="flight_logo">
                                                        <div class="flight-image i-${details.itineraries[1].segments[0].carrierCode.toString().toLowerCase()}">
                                                        </div>
                                                    </div>
                                                    <div class="flight_search_destination">
                                                        <h3>${that.searchData.to}</h3>
                                                        <p class="time">
                                                            ${new
                                    Date(details.itineraries[1].segments[0].departure.at).toLocaleTimeString('fr-FR',
                                        {
                                            hour:
                                                '2-digit', minute: '2-digit'
                                        })}
                                                        </p>
                                                        <p class="date">
                                                            ${new
                                    Date(details.itineraries[1].segments[0].departure.at).toLocaleDateString('en-US',
                                        { day: 'numeric' })}
                                                            ${that.$t(new
                                            Date(details.itineraries[1].segments[0].departure.at).toLocaleDateString('en-US', {
                                                month:
                                                    'long'
                                            }))}
                                                            ${new
                                    Date(details.itineraries[1].segments[0].departure.at).getFullYear()}
                                                        </p>
                                                        <h6>${that.getLocationByCode(that.searchData.to)['name']}</h6>
                                                    </div>
                                                </div>
                                                <div class="flight_right_arrow">
                                                        <img src="${require(`@/assets/img/icon/right_arrow.png`)}"
                                                            alt="img" />
                                                        <h6>
                                                            ${details.itineraries[1].segments.length - 1 == 0 ?
                                    that.$t('Direct Flight')
                                    : details.itineraries[1].segments.length - 1 + ' ' + that.$t('Stop')
                                }
                                                        </h6>
                                                        <p>${that.convertDuration(details.itineraries[1].duration)}</p>
                                                    </div>
                                                <div class="flight_search_middel">
                                                   
                                                    <div class="flight_search_destination">
                                                        <h3>${that.searchData.from}</h3>
                                                        <p class="time">
                                                            ${new
                                    Date(details.itineraries[1].segments[details.itineraries[1].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR',
                                        {
                                            hour:
                                                '2-digit', minute: '2-digit'
                                        })}
                                                        </p>
                                                        <p class="date">
                                                            ${new
                                    Date(details.itineraries[1].segments[details.itineraries[1].segments.length - 1].arrival.at).toLocaleDateString('en-US',
                                        { day: 'numeric' })}
                                                            ${that.$t(new
                                            Date(details.itineraries[1].segments[details.itineraries[1].segments.length - 1].arrival.at).toLocaleDateString('en-US', {
                                                month:
                                                    'long'
                                            }))}
                                                            ${new
                                    Date(details.itineraries[1].segments[details.itineraries[1].segments.length - 1].arrival.at).getFullYear()}
                                                        </p>
                                                        <h6>${that.getLocationByCode(that.searchData.from)['name']}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flight_search_right">
                                            <a 
                                                class="btn btn_theme btn_sm change-flight" data-type="arrival">
                                                <span>${that.$t('Change')}</span>
                                                <div data-v-caebf3bc="" class="loader-inner ball-pulse" style="transform: scale(0.7); display: none;"><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div></div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                    `);
                            $('.disable').show();
                            $('.price-fl').show();
                        }
                    } else {
                        if (need_approval == true) {
                            localStorage.setItem('need_approval', 1);
                        } else {
                            localStorage.setItem('need_approval', 0);
                        }
                        localStorage.removeItem("arrival_flight");
                        localStorage.setItem('departure_flight', JSON.stringify(details));
                        that.departure_selecting = 0;
                        var itineraries = ``;
                        details.itineraries.forEach(itinerarie => {
                            itinerarie.segments.forEach(segment => {
                                itineraries += `
                        <div class="itineraries">
                                        <div class="flight_multis_area_wrapper">
                                            <div class="flight_search_left">
                                                <div class="flight_logo">
                                                    <div class="flight-image i-${segment.carrierCode.toString().toLowerCase()}"></div>
                                                </div>
                                                <div class="flight_search_destination">
                                                    <h3>${segment.departure.iataCode}</h3>
                                                    <p class="time">
                                                                ${new
                                        Date(segment.departure.at).toLocaleTimeString('fr-FR',
                                            {
                                                hour:
                                                    '2-digit', minute: '2-digit'
                                            })}
                                                            </p>
                                                            <p class="date">
                                                                ${new
                                        Date(segment.departure.at).toLocaleDateString('en-US',
                                            { day: 'numeric' })}
                                                                ${that.$t(new
                                                Date(segment.departure.at).toLocaleDateString('en-US', {
                                                    month:
                                                        'long'
                                                }))}
                                                                ${new
                                        Date(segment.departure.at).getFullYear()}
                                                            </p>
                                                    <h6>${that.getLocationByCode(segment.departure.iataCode)['name']}</h6>
                                                </div>
                                            </div>
                                            <div class="flight_right_arrow"><img
                                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU7SURBVHgB5Vs7b+NGEB5Sb8t3kJsUqXh9AJ/rFJH+QHL5B1ekt+8X+FykzrkPcO5S5vEDIqVIgAABYidp0kSsUgQJ7i6+k08PcjMfH4ZE74OUKJJCPmBsibtL7qeZWQ53hhZtCUKIHv/rszgshywPWXrR92W4kbxkuWIZsVxalvWSqg6QZDllGYrNMWQ5YXGoauBJ9UU+JHXk+1Q2CiCaxJjlERUNvqhTMNEknouiTJ0vdMzyQpSPMctjyggrbUcRrrqnLCcZxpA3Z/F8Ej6R7wk+Fh6PYdsWWSx2jahWs6lWD79nwDNe0Z+k7ZzqzBHZIYW3FlNfmk998hZMdOHTOrBrFjVbtSzkL1k+ZuKuqaPxbCL0FZB1DP0CopBlDW6KetOmVruWhrjLMjCR1p4lLdnZWy93okk0mTTEAJflSBe0mAj/TBozFr6gmzeLwDeLAPy9s183aRvmPVCRtlWjmOxnpCG7mPk0uS6OLODzDzy5ntNirl0bMOdTVaP0p4qW++eqQTBhSJlIYeJPWMvPkgfvEDb5bRXIxjCQhkkfJRcxmUnDHBzZGWBKVSELYC6LmXI+uJXesdIVwiKMUx/LRmOBmk6qQzbG9MYL5qYAYv3+8oEVk0a4RgrtTv6dB4tGFYFAZe9eQ9U8YrMe3PaNP0S/hCMbAdOpKlkAdwqNq61oedmkpUs5zKVKfqvCfOrpAp9bboFJRyvzWNZzOlnQfLZeTFw0DKv2AYKRWMPSh2pod1fIAgYtB095MeGPZD3wxLNLAFfE9Ap8gD9W9Oj3QtYjDB13R8NArW4H8bYCB9CwNF6GOe8aWQDP4Bqz7oNwXz6weHP+87cF/fTFlDYFdlkUcKD7Q+kgr3jCv3wzI/fHOV3/5dPguEPrAnNXGPUhNNyTtfglEH7/kzbde8em37+d0fD8htaFJtR8CMJOxkFbA8h++Gl3Y9Ia6+wpCZcVSuZCWuh9OBeM2fd+ZR/MGyANZPFp3dZaboT/+cMLVtltIM/zIvCQ/h5vXs0o6yZknhP74fO39PfYWzHxLNjvNaXHoWGXJH7MgXbmbdd338vHYOC3m5DV7Gq6OJN8O7OWKd2RG0AWfrsuWcA2EL6StWTM7+SC79mMNyULaJT1Cme8lLXUStBwq0sbkwU0c7+0oo27L5MtcF8sXLuI7v2GykIH2sfDm9eLtTOAZcGwoXdgRzmYkawV6cpdA9KsCoyWt3i+k/Vo8GBrxzhrlPQ1/sSbeEqzrlJqxQTkktt7yljgAdIugYZ1Zr1LWm61tebs4sPy2n8m6wmyjZYxEV06mvoqgVtuyVQLsoZ92QjkZcvYFEgDm9W2d7+panZZuw9u+yYaz1SjOt16JU0bc+rsN3RdVip87NXB1ogUvgxzaXWqZ9qtPW0JxAVz+mr5gCohjtoO6V7XDiXEXZJU9dwJWKMOZ2tepDCkmMeZrIRJGqFHtRHnpLlYuySfxjVxrzWQPWcOF9LxqhFpqu+CsqXXSJRTIUB5YqfbMJYtMdkjVaOpTguk4c+Ort+2/TqOBVIWpmmr8fIrPYwS53mmV2OijZYdbDkZ4NKmpYcxItJ4ZjYXl/oiyEvNOG25bjIOGUA8BKQkCmir75aRadlh4ljMjlP3j8ijfNj3oozk0gY/uIAQnmEtOyofblhpScbA4vp0ay+FoEovKs4uGyhST127vSlpvAJwIcrDUJTxtgtf9JEoVttD8T95u2VYCaJJiNDUT0R+L2o9FWEskBu2FhxGE8VtrE9hlUH8Gp6T6OpSmP3AreUq+j7a1qr7H/X8vJFKEe/RAAAAAElFTkSuQmCC"
                                                        alt="img">
                                                    <h6> 
                                                        ${new Date(segment.departure.at).toLocaleDateString('en-US', { day: 'numeric' })}
                                                        ${that.$t(new Date(segment.departure.at).toLocaleDateString('en-US', { month: 'long' }))}
                                                        ${new Date(segment.departure.at).getFullYear()}
                                                    </h6>
                                                    <p>${that.convertDuration(segment.duration)}</p>
                                                </div>
                                            <div class="flight_search_middel">
                                                <div class="flight_search_destination">
                                                    <h3>${segment.arrival.iataCode}</h3>
                                                    <p class="time">
                                                                ${new
                                        Date(segment.arrival.at).toLocaleTimeString('fr-FR',
                                            {
                                                hour:
                                                    '2-digit', minute: '2-digit'
                                            })}
                                                            </p>
                                                            <p class="date">
                                                                ${new
                                        Date(segment.arrival.at).toLocaleDateString('en-US',
                                            { day: 'numeric' })}
                                                                ${that.$t(new
                                                Date(segment.arrival.at).toLocaleDateString('en-US', {
                                                    month:
                                                        'long'
                                                }))}
                                                                ${new
                                        Date(segment.arrival.at).getFullYear()}
                                                            </p>
                                                    <h6>${that.getLocationByCode(segment.arrival.iataCode)['name']}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        `;
                            });
                        });
                        $('#departure-result .flight-result-con').hide();
                        $('#departure-result .selected-flight').html(`
                         <div class="flight_search_item_wrappper">
                            <div class="flight_search_items multi_city">
                                <div class="multi_city_flight_lists w-100">
                                  ${itineraries}
                                </div>
                                <div class="flight_search_right">
                                            <a 
                                                class="btn btn_theme btn_sm  change-flight" data-type="multi_city">
                                                   <span>${that.$t('Change')}</span>
                                                   <div data-v-caebf3bc="" class="loader-inner ball-pulse" style="transform: scale(0.7); display: none;"><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div><div style="background-color: rgb(255, 255, 255);"></div></div>
                                            </a>
                                </div>
                            </div>
                        </div>
                        `);
                        $('.disable').show();
                        $('.price-fl').show();
                    }
                }, 10);
                setTimeout(() => {
                    $(this).prop('disabled', false);
                    $(this).find('span').show();
                    $(this).find('.loader-inner').hide();
                }, 500);
            });
            $(document).on('click', '.change-flight', function () {
                var type = $(this).data('type');
                $(this).prop('disabled', true);
                $(this).find('span').hide();
                $(this).find('.loader-inner').show();
                setTimeout(() => {
                    if (type == 'multi_city') {
                        $(".filter-airlines").attr('disabled', false);
                        $('.disable').hide();
                        $('.price-fl').hide();
                        $('#departure-result .flight-result-con').show();
                        $('#departure-result .selected-flight').html('');
                        that.departure_selecting = 1;
                    } else {
                        if (type == 'departure') {
                            that.departure_selecting = 1;
                            that.arrival_selecting = 1;
                            that.stops = that.getUniqueSegmentLengths(that.allData.data).sort(function (a, b) {
                                return a - b;
                            });
                            that.count = that.result.data.length;
                            $(".filter-stops").each(function (index) {
                                if (index != 0) {
                                    $(this).prop('checked', false);
                                }
                            });
                            $(".filter-airlines").attr('disabled', false);
                            $('.disable').hide();
                            $('.price-fl').hide();
                            $('#arrival-result').hide();
                            $('#arrival-result .selected-flight').html('');
                            $('#departure-result .selected-flight').html('');
                            $('#departure-result .flight-result-con').show();
                        } else {
                            that.arrival_selecting = 1;
                            $('.disable').hide();
                            $('.price-fl').hide();
                            $('#arrival-result').show();
                            $('#arrival-result .selected-flight').html('');
                            $('#arrival-result .flight-result-con').show();
                        }
                    }
                }, 10);
            });
        },
    },
    mounted() {
        that = this;
        this.Jquery();
        var targetTop = $("#target-div").offset().top;
        this.tripType = localStorage.getItem("tripType");
        this.is_self_paying = localStorage.getItem("is_self_paying");
        this.allowed_to_make_exception = localStorage.getItem("allowed_to_make_exception");
        var can_request_help = localStorage.getItem("can_request_help"),
            allowed_to_choose_need_help_option = localStorage.getItem("allowed_to_choose_need_help_option");
        var scroll = 0;
        if (allowed_to_choose_need_help_option == 0 || can_request_help == 'false') {
            scroll = -50;
        }
        if (this.tripType != 'multi_city') {
            $("html, body").animate({ scrollTop: targetTop + scroll + 110 }, 'slow');
        } else {
            $("html, body").animate({ scrollTop: targetTop + scroll + 225 }, 'slow');
        }
        if (localStorage.getItem("guest_id") || localStorage.getItem("user_token")) {
            if (localStorage.getItem("searchData")) {
                this.searchData = JSON.parse(localStorage.getItem("searchData"));
                var ticket_price = JSON.parse(localStorage.getItem("max_ticket_price"));
                if (ticket_price.length > 0) {
                    if (this.searchData.cabin == 'ECONOMY') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.class === 'economy');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    } else if (this.searchData.cabin == 'BUSINESS') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.class === 'business');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    } else if (this.searchData.cabin == 'FIRST') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.class === 'first class');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    }
                }
                if (this.is_self_paying == 1) {
                    this.max_ticket_price = 500000000;
                }
                var currency = this.searchData.currency,
                    from = this.searchData.from,
                    to = this.searchData.to,
                    date = this.searchData.date,
                    ret_date = this.searchData.ret_date,
                    adults = this.searchData.adults,
                    children = this.searchData.children,
                    infants = this.searchData.infants,
                    cabin = this.searchData.cabin,
                    nonStop = false,
                    max = 15,
                    maxPrice = this.allowed_to_make_exception == 0 ? this.max_ticket_price : "",
                    params = {
                        currency: currency,
                        from: from,
                        to: to,
                        date: date,
                        ret_date: ret_date,
                        adults: adults,
                        children: children,
                        infants: infants,
                        cabin: cabin,
                        nonStop: nonStop,
                        maxPrice: maxPrice,
                        max: max
                    };
                if (this.tripType == 'multi_city') {
                    const params = new URLSearchParams(this.searchData.info);
                    from = JSON.stringify(params.getAll('from[]'));
                    to = JSON.stringify(params.getAll('to[]'));
                    date = JSON.stringify(params.getAll('date[]'));
                    params = {
                        currency: currency,
                        from: from,
                        to: to,
                        date: date,
                        adults: adults,
                        children: children,
                        infants: infants,
                        cabin: cabin,
                        nonStop: nonStop,
                        maxPrice: maxPrice,
                        max: max,
                        type: 'multi-city'
                    };
                }
                flightsService.get_flight_offers(params).then((response) => {
                    const data = response.data.data;
                    this.result = data;
                    this.allData = Object.assign([], data);
                    this.count = data.data.length;
                    this.airlines = data.airlines;
                    this.date = new Date(date);
                    this.ret_date = new Date(ret_date);
                    if (this.result.data.length == 0) {
                        $('#noFlights').show();
                        toast.error(this.$t('There are no flights available'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 2500);

                    } else {
                        data.data.forEach(element => {
                            element.itineraries[0].segments.forEach(segments => {
                                that.airlines[segments.carrierCode] = airlinesData[segments.carrierCode];
                            });
                        });
                        this.stops = this.getUniqueSegmentLengths(data.data).sort(function (a, b) {
                            return a - b;
                        });
                        if (this.tripType != 'multi_city') {
                            var array = [this.stops[0]];
                            const filteredFlights = this.allData.data.filter((flight) => {
                                if (array.includes(flight.itineraries[0].segments.length)) {
                                    return true;
                                }
                                return false;
                            });
                            this.count = filteredFlights.length;
                            this.result.data = filteredFlights;
                        }
                    }
                    if (response.data.status == 0) {
                        this.$toast.open({
                            message: response.data.message,
                            type: 'error',
                            position: 'top-right',
                            duration: 2500
                        });
                    } else {
                        $('.searching').hide();
                        $('.found').show();
                        setTimeout(() => {
                            $('#searchloader').hide();
                            $('.flights-div').css('display', 'flex');
                        }, 2000);
                    }
                });
            }
        } else {
            $('.pre-loader').hide();
            this.$router.replace(`/error`);
        }
    },
};
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss" scoped>
@media (min-width: 1200px)
{
.container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1290px;
}
}
.section_padding {
    background: #fcfcfc;
    padding: 65px 0;
}

.flight_inner_show_component {
    justify-content: center;
}

.airline-details {
    justify-content: flex-start;
}

.flight_show_down_wrapper {
    padding-top: 25px;
    padding-bottom: 25px;
}


.disable {
    display: none;
    position: absolute;
    width: calc(100% - 0px);
    height: calc(100% - 0px);
    background-color: rgba(139, 62, 234, 0.07);
    z-index: 8;
    cursor: not-allowed;
    margin-left: 0px;
    transition: 0.3s;
    left: 0px;
    border-radius: 8px;
}

.price-fl .txt-price {
    font-size: 1.75rem;
}
.col-md-offset-8 {
    margin-left: 63.64%;
    margin-right: 0;
}
.rtl .col-md-offset-8 {
    margin-right: 63.64%;
    margin-left: 0;
}

.new-bold-dark {
    font-weight: 400;
    color: var(--main-color);
}

.btn-fa-primary {
    background-color: var(--main-color);
    border: 0;
    color: #fff;
    outline: 0;
    box-shadow: none;
    border-radius: 5px;
    transition: .3s;
    margin-top: 10px;

    &:hover {
        background-color: var(--black-color);
    }
}

.btn-block {
    display: block;
    width: 100%;
}

.p15 {
    padding: 15px !important;
}
</style>
<style lang="scss">
.flight_logo {
    width: 92px;
    text-align: -webkit-center;
}

.area_flex_one span {
    color: var(--black-color);
    font-weight: 500;
    padding-top: 5px;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 180px;
}

#noFlights .seatNotFound,
#searchloader .searching {
    width: 60%;
}

#searchloader .searching-con {
    text-align: center;
}

#noFlights,
#searchloader {
    height: 100% !important;
}

#noFlights,
#searchloader {
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    height: calc(100% - 0px);
}

#noFlights .no-search-con,
#searchloader .search-con {
    width: 600px;
    border-radius: 3px;
}

.pl0 {
    padding-left: 0 !important;
}

.mt20 {
    margin-top: 20px !important;
}

.p15 {
    padding: 15px !important;
}

#searchloader .searching-con {
    width: 400px;
    height: 400px;
    display: block;
    border-radius: 50%;
    margin: auto;
}

#noFlights .seatNotFound,
#searchloader .searching {
    display: inline-block;
    width: 100%;
    -webkit-animation: booble 1.3s infinite ease-in;
    -moz-animation: booble 1.3s infinite ease-in;
    -o-animation: booble 1.3s infinite ease-in;
    animation: booble 1.3s infinite ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    border-radius: inherit;
}

#noFlights .no-searching-con {
    width: 400px;
    height: 340px;
    display: block;
    border-radius: 50%;
    margin: auto;
}

#noFlights .seatNotFound,
#searchloader .searching {
    display: inline-block;
    width: 100%;
    -webkit-animation: booble 1.3s infinite ease-in;
    -moz-animation: booble 1.3s infinite ease-in;
    -o-animation: booble 1.3s infinite ease-in;
    animation: booble 1.3s infinite ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    border-radius: inherit;
}
.rtl{
    .skeleton {
        .flight_right_arrow img {
            rotate: 180deg;
        } 
    }
}
.skeleton {
    .flight_search_right {
        background: #f3eff900;
        padding: 25px 16px 20px 25px;
        border-right: 1px solid #ddd;
    }

    .flight-image {
        filter: grayscale(95%) brightness(175%);
    }

    .flight_right_arrow img {
        filter: brightness(130%);
        box-shadow: 1px 4px 12px rgba(0, 0, 0, 0.0);
    }

    .left_side_search_heading h5 {
        padding-bottom: 20px;
        text-align: center;
    }

    .filter-price {
        padding-top: 15px;
        padding-bottom: 0px;
        text-align: center;
    }

    .tour_search_type .form-check {
        text-align: center;
        padding-left: 0px;
    }
}
.rtl .multi_city {
    .multi_city_flight_lists {
        border-left: 1px dashed #ddd;

        .itineraries {
            padding: 18px 25px;
            border-bottom: 1px dashed #ddd;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .flight_search_right {
        background: #fff;
    }
    .flight_right_arrow img{
        width:50px;
        height:50px;
    }
}
.multi_city {
    .multi_city_flight_lists {
        border-right: 1px dashed #ddd;

        .itineraries {
            padding: 18px 25px;
            border-bottom: 1px dashed #ddd;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .flight_search_right {
        background: #fff;
    }
    .flight_right_arrow img{
        width:50px;
        height:50px;
    }
}
</style>